import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Formik, Form,} from "formik";
import "../styles/research.scss";
import LoaderFull from "~components/Form/components/LoaderFull";
import FileList from "../Components/Form/View/FileList";
import Simple from "../Components/Form/View/Simple";
import Checklist from "../Components/Form/View/Checklist";
import Radio from "../Components/Form/View/Radio";
import Titles from "../Components/Form/View/Titles";
import { useGetPesquisaClienteFile } from "../hooks/useResearchManagementRequests";
import { db } from "~db/db";
import useMimeInfo from "~fetchs/useMimeInfo";
import ClientHeader from "~components/ClientInfo/ClientHeader";
import useCliente from "~fetchs/useCliente";

const ViewResearch = () => {
  const { parameter: id } = useParams();

  const [ clienteId, setClienteId] = useState(0);
  const [ pesquisaCampoCliente, setPesquisaCampoCliente ] = useState([])
  const [ pesquisaDados, setPesquisaDados ] = useState([]);
  const [ initialValues, setInitialValues ] = useState({});
  const [ hook, setHook ] = useState(0);
  const [ downloadFileData, setDownloadFileData] = useState(null);

  const { cliente } = useCliente(clienteId);

  const { mimeTypes } = useMimeInfo();

  const { refetch } = useGetPesquisaClienteFile(id, downloadFileData?.nome);

  const handleDownload = (base64Data, fileName, mimeType = "image/jpeg") => {
    const base64WithoutPrefix = base64Data.split(',').pop();


    const byteCharacters = atob(base64WithoutPrefix);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([byteNumbers], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (downloadFileData?.nome && refetch) {
      refetch()
        .then(result => {
          if(result.data?.isSuccess) {
            if(result.data?.data) {
              console.log(downloadFileData);
              const mime = mimeTypes[downloadFileData.extensao.replace('.','')] ?? null;

              if(mime){
                handleDownload(result.data.data, downloadFileData.nome, mime);
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        }).finally(e => {
          setDownloadFileData(null);
        });
    }
  }, [downloadFileData]);

  useEffect(() => {
    if (pesquisaDados && Object.entries(pesquisaDados)?.length > 0) {
      const computeInitialValues = (fields) => {
        return (fields || []).reduce((acc, item) => {
          const id = `${item.id}`;
          const t = item.type;

          if (t === "checklist") {
            acc[id] = item.chosen;
            return acc;
          }

          if (t === "file" || t === 6) {
            acc[id] = item.documentos ?? [];
            return acc;
          }

          if (t === "select") {
            acc[id] = item.chosen;
            return acc;
          }

          if (t === "radio" || t === "number" || t === "text" || t === "date") {
            const answer = item.chosen?.[0] ?? "";
            switch(t) {
              case "date":
                acc[id] = answer ? answer.split("-").reverse().join("/") : "";
                break;
              default:
                acc[id] = answer;
                break;
            }
            return acc;
          }

          acc[id] = "";
          return acc;
        }, {});
      };

      const values = computeInitialValues(pesquisaCampoCliente);
      setInitialValues(values);
      setHook((prev) => prev + 1);
    }
  }, [pesquisaDados, pesquisaCampoCliente]);

  const FieldContent = ({ field, values, setFieldValue }) => {
    const commonProps = { field, values };

    switch (field.type) {
      case "date":
      case "text":
      case "number":
      case "select":
        return <Simple {...commonProps} />;

      case "radio":
        return <Radio {...commonProps} values={values} setFieldValue={setFieldValue} />;

      case "checklist":
        return <Checklist {...commonProps} values={values} />;

      case "foto":
      case "file":
        return (field?.documentos?.length > 0)
          ? <FileList files={field.documentos} setDownloadFileData={setDownloadFileData} />
          : <Simple {...commonProps} />;

      default:
        return null;
    }
  };


  const fetchData = async () => {
    const filter = await db.pesquisaCampoCliente.where('id').equals(parseInt(id)).first();

    if (id && filter) {
      setPesquisaDados(filter);
      setClienteId(filter?.clienteId);
      setPesquisaCampoCliente((filter.pesquisa || []));
    }
  };

  useEffect(() => {
    if (id > 0) {
      fetchData();
    }
  }, [id]);

  return (
    <>
      <ClientHeader dados={cliente} />
      <Formik
        initialValues={initialValues}
        validationSchema={null}
        onSubmit={null}
        validateOnChange={true}
        validateOnBlur={true}
        key={hook}
      >
        {({ values, setFieldValue }) => (
          <Form className="container research" id="emissor">
            {pesquisaCampoCliente ? (
              <>
                {pesquisaCampoCliente[0] && pesquisaCampoCliente[0].id === 0 && (
                  <h1 className="research__title">
                    <span>Pesquisa:</span>
                    {pesquisaCampoCliente[0]?.value}
                  </h1>
                )}
                {pesquisaCampoCliente.map((field) => {
                  if (field.id === 0) return null;

                  return (
                    <div
                      key={field.id}
                      className={`research__field bg-white px-7  pt-7 pb-10 rounded-[10px] shadow-lg mt-4 mb-6 ${field.type}`}
                    >
                      <Titles field={field} />
                      <div className={`content-${field.type}`}>
                        <FieldContent field={field} values={values} setFieldValue={setFieldValue} />
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
                <LoaderFull />
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ViewResearch;
